import { Component, EventEmitter, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { ColDef } from 'ag-grid-community';
import { AppState } from 'src/app/app.state';
import { ExportableColDefWithTitle } from 'src/app/shared/ag-grid-config/store/ag-grid-config/ag-grid-config.reducer';
import { BusinessUnitViewModel } from 'src/app/shared/models/autogenerated';
import { AdapCellClassRules } from 'src/app/shared/utils/ag-grid-utils';
import { nameof } from 'src/app/shared/utils/nameof';
import { AgGridButtonRenderer } from 'src/app/shared/components/ag-grid-button-renderer/ag-grid-button-renderer.component';
import {
  AgGridButtonRendererActions,
  AgGridButtonRendererModel,
} from 'src/app/shared/models/ag-grid-button-renderer.model';
import { BusinessUnitsTableActionsRendererComponent } from '../business-units-actions-renderer/business-units-actions-renderer.component';
import { BusinessUnitGridCellActions } from '../../models/business-unit-grid-cell-actions.model';
import { selectAllBusinessUnits } from '../../store/global-settings.selectors';

@Component({
  standalone: false,
  selector: 'app-business-units-table',
  templateUrl: './business-units-table.component.html',
  styleUrls: ['./business-units-table.component.scss'],
})
export class BusinessUnitsTableComponent {
  businessUnits$ = this.store.select(selectAllBusinessUnits);

  @Output() editBusinessUnit = new EventEmitter<string>();
  @Output() deleteBusinessUnit = new EventEmitter<string>();

  configStoreTableName: string = 'businessUnits';
  configStoreRouteIdName: string = 'phaseId';

  components = {};

  defaultColDef: ColDef = {
    sortable: true,
    filter: true,
    filterParams: {
      newRowsAction: 'keep',
    },
    resizable: true,
    cellClassRules: AdapCellClassRules,
  };

  columnDefs: ExportableColDefWithTitle[] = [
    {
      field: nameof<BusinessUnitViewModel>('code'),
      headerName: 'code',
      maxWidth: 170,
    },
    {
      field: nameof<BusinessUnitViewModel>('name'),
      headerName: 'name',
      cellRenderer: AgGridButtonRenderer,
      cellRendererParams: {
        onInit: (
          actions: AgGridButtonRendererActions,
          data: BusinessUnitViewModel
        ) => {
          actions.setProps({
            text: data.name,
            style: 'blank',
            action: (data: BusinessUnitViewModel) => {
              this.editBusinessUnit.emit(data.id);
            },
          });
        },
      } as AgGridButtonRendererModel,
    },
    {
      field: nameof<BusinessUnitViewModel>('region'),
      headerName: 'region',
      maxWidth: 200,
      valueGetter: (params: { data: BusinessUnitViewModel }) => {
        return params.data.region;
      },
    },
    {
      maxWidth: 60,
      sortable: false,
      filter: false,
      resizable: false,
      cellRenderer: BusinessUnitsTableActionsRendererComponent,
      cellRendererParams: {
        onDeleteClick: (businessUnitId: string) =>
          this.deleteBusinessUnit.emit(businessUnitId),
      } as BusinessUnitGridCellActions,
      pinned: 'right',
      ignoreExport: true,
    },
  ];

  constructor(private store: Store<AppState>) {}
}
